import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner"
import { SearchService } from "../services/transaction.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { BankService } from "../services/bank.service";
import * as XLSX from 'xlsx';
import { APP_CONSTS } from '../consts/app.consts';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';

const defaults = {
    notify: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
    }
}
@Component({
    selector: 'app-transactions',
    templateUrl: './transactions.component.html',
    styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit {

    tran: SearchService = {
        date: '',
        search: ''
    };
    searchObj = {
        time1: new Date(),
        time: new Date(),
        search: ''
    }

    /*store all transaction list variable*/
    public settings: any
    transactions: Array<any>;
    deposits: Array<any>;
    //   depositslist =[];
    depositslist: Array<any>;


    search = '';

    /* Search variables */
    serach: string;
    FilPerpage: number;
    FilPage: number;
    actionSearch: string;
    filterAction: Boolean;
    filter: Boolean;
    /************************************/
    // pager Number
    pager: number;
    Tpager: number;
    currentPage = 0;
    csrf_token: any = '';
    /* Hide / show variables */
    TransactionActive: string;

    // array of all items to be paged
    private allItems1: any[];

    // pager object
    pager1: any = {};
    datePickerConfig: any = {};
    transactionlist = [];
    fileName: string;
    constructor(private userService: UserService, private router: Router,
        private spinnerService: Ng4LoadingSpinnerService,
        private notifSer: NotificationsService,
        private pagerService: PagerserviceService,
        private bankService: BankService,
        private dialog: MatDialog) { }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.serach = '';
            this.actionSearch = 'Search';
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.TransactionActive = null;
            this.filterAction = true;
            this.filter = false;
            this.geDepositsLists();
            this.csrf();
        }
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.csrf_token = success._csrf;
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    TransactionDetails(i) {
        this.TransactionActive = i;
    }

    TransactionDetailshide() {
        this.TransactionActive = null;
    }
    showCompleteCancelButton(trans){
        return trans.status==APP_CONSTS.TRANSACTION_STATUS.EXCHANGE_PENDING
    }
    updateCompleteDeposit(deposit) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: `Are you sure want to complete the deposit?`,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notify } = defaults;
                deposit['_csrf'] = this.csrf_token;
                this.bankService.updateCompleteDeposit(deposit).subscribe((success) => {
                    this.spinnerService.hide();
                    this.geDepositsLists();
                    this.notifSer.success(
                        'Success',
                        success.message,
                        notify
                    )
                }, err => {
                    this.notifSer.error(
                        'Error',
                        err.error.message,
                        notify
                    )
                });
            }
        });
    }
    updateCancelDeposit(deposit) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: `Are you sure want to cancel the deposit?`,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notify } = defaults;
                deposit['_csrf'] = this.csrf_token;
                this.bankService.updateCancelDeposit(deposit).subscribe((success) => {
                    this.spinnerService.hide();
                    this.geDepositsLists();
                    this.notifSer.success(
                        'Success',
                        success.message,
                        notify
                    )
                }, err => {
                    this.notifSer.error(
                        'Error',
                        err.error.message,
                        notify
                    )
                });
            }
        });
    }
    geDepositsLists() {
        this.bankService.getdepositlists(this.FilPerpage, this.FilPage, this.searchObj, false).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                this.deposits = success.withdraw;
                this.depositslist = success.withdraw;
                this.Tpager = success.pages;
                this.currentPage = success.current;
                this.setPage(this.FilPage);
            }
        }, (error) => {
            this.deposits = [];
            this.depositslist = []
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    geDepositsListsexp() {
        this.bankService.getdepositlists(this.FilPerpage, this.FilPage, this.searchObj, true).subscribe((success) => {
            this.spinnerService.hide();
            if (success.status) {
                var depositslist = success.withdraw;
                var transactionlist = [];
                for (let i = 0; i < depositslist.length; i++) {
                    transactionlist.push({
                        'Timestamp': depositslist[i].createdAt ? depositslist[i].createdAt : '',
                        'Legal Name': depositslist[i].user[0].name ? depositslist[i].user[0].name : '',
                        'Email': depositslist[i].user[0].email ? depositslist[i].user[0].email : '',
                        'Cryptocurrency Name': depositslist[i].currency ? depositslist[i].currency : '',
                        'Amount': depositslist[i].amount ? depositslist[i].amount : '',
                        'Fee': depositslist[i].fee ? depositslist[i].fee : '',
                        'Deposit Address': depositslist[i].address ? depositslist[i].amount : '',
                        'Transaction id': depositslist[i].txnid ? depositslist[i].txnid : '',
                        'txHash': depositslist[i].txHash ? depositslist[i].txHash : '',
                        'Txn type': depositslist[i].txntype ? depositslist[i].txntype : 'Automatic',
                        'Status': depositslist[i].status ? depositslist[i].status : '',
                        'Approved By': depositslist[i].adminid
                    })
                }
                this.fileName = 'Crypto Deposit Report.xlsx'
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transactionlist);

                /* generate workbook and add the worksheet */
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

                /* save to file */
                XLSX.writeFile(wb, this.fileName);
            }
        }, (error) => {
        })
    }


    SearchDeposit(target) {
        this.spinnerService.show();
        this.searchObj.search = target.target.value;
        this.bankService.getdepositlists(this.FilPerpage, this.FilPage, this.searchObj, false).subscribe((success) => {
            if (success.status) {
                this.depositslist = success.withdraw;
                this.Tpager = success.pages;
                this.setPage(this.FilPage);
            }
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.geDepositsLists();
    }
    /**
 * 
 * @param report export excel
 */
    exportExcel(report) {
        this.fileName = 'TransactionReport.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.transactionlist);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);
    }
}



// WEBPACK FOOTER //
// ./src/app/transactions/transactions.component.ts